import * as htmlToImage from "html-to-image";

/**
 * Exporta un elemento HTML a imagen PNG.
 * @param elementId - ID del contenedor (ej. "chart-zonas")
 * @param filename - Nombre del archivo de descarga
 */
export const exportChartAsImage = async (
  elementId: string,
  filename: string = "grafica.png"
): Promise<void> => {
  const node = document.getElementById(elementId);
  if (!node) {
    alert("No se encontró el elemento del gráfico.");
    return;
  }

  try {
    const dataUrl = await htmlToImage.toPng(node, {
      backgroundColor: "#ffffff",
      quality: 1,
      pixelRatio: 2, // mejora resolución
    });

    const link = document.createElement("a");
    link.download = filename;
    link.href = dataUrl;
    link.click();
  } catch (error) {
    console.error("Error exportando la imagen:", error);
    alert("Hubo un error al exportar la gráfica.");
  }
};
